/*
 * BottomBar
 * @module components
 * @flow
 */

import React from 'react';
import styled from 'styled-components/macro';
import { palette } from 'styled-theme';

import { Tabs } from '~/components/Tabs';

export type BottomBarProps = {
  children: () => React$Node,
  palette?: string,
};

const BottomBarWrapper = styled(Tabs)`
  position: fixed;
  bottom: 0;
  display: flex;
  padding: 0;
  /* NOTE: bottom bar for mobile devices must have z-index value lower than announcements popup */
  z-index: 997;
  width: 100%;
  height: 60px;
  background-color: ${palette(1)};
  box-shadow: none;
  justify-content: space-around;
  overflow: visible;
  transition: bottom 0.5s ease;
`;

/**
 * BottomBar React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {React.Children} [props.children] - children
 * @param {string} [props.palette] - palette
 * @example <caption>Simple usage</caption>
 * <BottomBar><BottomBarItem icon={<IconWallet />}>My Wealth</BottomBarItem></BottomBar>
 * @returns {React.Node<*>} React-component
 */
export const BottomBar = ({ children, palette }: BottomBarProps) => (
  <BottomBarWrapper palette={palette} testid="bottom-bar">
    {children()}
  </BottomBarWrapper>
);

BottomBar.defaultProps = {
  palette: 'primary',
};
